import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import config from '../../config';
import { Row, Col, Table } from 'react-bootstrap';
import AdminSteps from '../common/AdminSteps';
import Spinner from 'react-spinkit';
import { Link } from 'react-router';
import * as runActions from '../../actions/runsActionCreators';
import * as courseActions from '../../actions/coursesActionCreators';
import * as studentActions from '../../actions/studentsActionCreators';
import * as commonActions from '../../actions/commonActions';
import * as groupActions from '../../actions/groupActionCreators';
import _ from 'underscore';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import DropdownList from 'react-widgets/lib/DropdownList';

class DashboardPage extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      allocationsLoaded: false,
      topRankedInAllocations: 0,
      topTwoRankedInAllocations: 0,
      topFiveRankedInAllocations: 0,
      showAll1: 10,
      showAll2: 10,
      showAll3: 10,
      showAllFave: 10,
      filterGroup: {
        id: null
      },
      allGroups: true
    };
    this.getCoursesWithPositivePrices = this.getCoursesWithPositivePrices.bind(this);
    this.getTopXClassesByPrice = this.getTopXClassesByPrice.bind(this);
    this.getCoursesOverDefaultStudBudgetHalf = this.getCoursesOverDefaultStudBudgetHalf.bind(this);
    this.joinCoursesAndStudents = this.joinCoursesAndStudents.bind(this);

    this.getCountVsTargetCourses = this.getCountVsTargetCourses.bind(this);
    this.countStudentFairness = this.countStudentFairness.bind(this);

    this.getTopRankedInAllocations = this.getTopRankedInAllocations.bind(this);
    this.getBelowRankingAllocations = this.getBelowRankingAllocations.bind(this);
    this.getStudentsWithRankingsBelowAllocations = this.getStudentsWithRankingsBelowAllocations.bind(this);

    this.getGroupStudentsCountWithFavorites = this.getGroupStudentsCountWithFavorites.bind(this);
    this.getGroupStudentsNoFavorite = this.getGroupStudentsNoFavorite.bind(this);

    this.getStudentsInGroup = this.getStudentsInGroup.bind(this);

    /* Students and fairness allGroups check handler */
    this.handleCheckAllGroups = this.handleCheckAllGroups.bind(this);
    this.getAllocationsByGroup = this.getAllocationsByGroup.bind(this);
  }

  componentWillMount() {
    if (!this.props.run.id) {
      this.props.runActions.getRun();
    }
    // If allocations are not loaded load them
    if (!this.props.run.allocations.courses) {
      this.setState({ allocationsLoaded: false });

      // For loading allocations Courses, Students and Groups must be in state so joinCoursesAndStudents() function can do the job
      Promise.all([
        this.props.courseActions.getAllCourses(),
        this.props.studentActions.getAllStudents(),
        this.props.groupActions.getAllGroups()
      ])
        .then(() => {
          const { computationId } = this.props.params || 0;
          this.props.runActions.getAllocations(computationId).then(() => {
            this.joinCoursesAndStudents();
          });
        })
        .catch(err => {
          console.log(err);
        });
    } else {
      this.joinCoursesAndStudents();
    }
  }

  handleCheckAllGroups() {
    this.setState({ allGroups: !this.state.allGroups });
  }

  getStudentFairness() {
    let allocationsStudents = this.getAllocationsByGroup();

    let topFive = this.getTopXClassesByPrice(5);
    let top5 = this.countStudentFairness(topFive, allocationsStudents);

    let topTen = this.getTopXClassesByPrice(10);
    let top10 = this.countStudentFairness(topTen, allocationsStudents);

    let topTwenty = this.getTopXClassesByPrice(20);
    let top20 = this.countStudentFairness(topTwenty, allocationsStudents);
    let a = [top5, top10, top20];
    return a;
  }

  countStudentFairness(top, students) {
    let topNoClasses = 0;
    let topOneClasses = 0;
    let topTwoClasses = 0;
    let topThreeClasses = 0;

    students.map(s => {
      let numOfClasses = 0;
      s.allocation.map(a => {
        let n = top.filter(c => {
          return c.id == a;
        });
        if (n[0]) {
          numOfClasses++;
        }
      });
      if (numOfClasses == 0) {
        topNoClasses++;
      } else if (numOfClasses == 1) {
        topOneClasses++;
      } else if (numOfClasses == 2) {
        topTwoClasses++;
      } else if (numOfClasses > 2) {
        topThreeClasses++;
      }
    });
    let array = [topNoClasses, topOneClasses, topTwoClasses, topThreeClasses];
    return array;
  }

  getAllocationsByGroup() {
    return this.getStudentsInGroup();
  }

  // Top ranked classes in allocations
  getTopRankedInAllocations() {
    let topRankedInAllocations = 0;
    let topTwoRankedInAllocations = 0;
    let topThreeRankedInAllocations = 0;
    let topFiveRankedInAllocations = 0;

    let allocationsStudents = this.getAllocationsByGroup();

    allocationsStudents.map(student => {
      let a = student.allocation.filter(a => {
        return a == student.rankings[0];
      });
      let b = student.allocation.filter(b => {
        return b == student.rankings[1];
      });
      let c = student.allocation.filter(c => {
        return c == student.rankings[2];
      });
      let d = student.allocation.filter(d => {
        return d == student.rankings[3];
      });
      let e = student.allocation.filter(e => {
        return e == student.rankings[4];
      });
      
      if (a[0]) {
        topRankedInAllocations++;
      }
      if (a[0] || b[0]) {
        topTwoRankedInAllocations++;
      }
      if (a[0] || b[0] || c[0]) {
        topThreeRankedInAllocations++;
      }

      if (a[0] || b[0] || c[0] || d[0] || e[0]) {
        topFiveRankedInAllocations++;
      }
    });

    topRankedInAllocations = Math.round((topRankedInAllocations / allocationsStudents.length) * 100);
    topTwoRankedInAllocations = Math.round((topTwoRankedInAllocations / allocationsStudents.length) * 100);
    topThreeRankedInAllocations = Math.round((topThreeRankedInAllocations / allocationsStudents.length) * 100);
    topFiveRankedInAllocations = Math.round((topFiveRankedInAllocations / allocationsStudents.length) * 100);

    return [topRankedInAllocations, topTwoRankedInAllocations, topThreeRankedInAllocations, topFiveRankedInAllocations, allocationsStudents.length];
  }

  // Returns x number of classes sorted DESC by price
  getTopXClassesByPrice(x) {
    let courses = _
      .sortBy(this.state.courses, 'price')
      .reverse()
      .filter(c => {
        return c.price;
      })
      .slice(0, x);
    return courses;
  }

  /*
  Function used on first table to show courses with top prices over 50.
  If there is more than 10 courses with price > 50 'show all/collapse' button is shown
   */
  getTopClassesByPrice() {
    let courses = _
      .sortBy(this.state.courses, 'price')
      .filter(course => course.target_capacity > 0)
      .reverse()
      .filter(c => {
        return c.price;
      });
    let moreThanFifty = courses.filter(c => {
      return c.price > 5000;
    });

    if (moreThanFifty.length < 10) {
      return courses.slice(0, 10);
    } else {
      return moreThanFifty;
    }
  }

  getCourseHaveZeroTargetCapacity(courses) {
    let zeroCapacityCourses = courses.filter(course => course.target_capacity === 0);
    let ids = zeroCapacityCourses.map(course => course.id);
    return ids;
  }

  getCoursesWithPositivePrices() {
    let cArray = this.props.run.allocations.courses.filter(course => {
      return course.price > 0;
    });
    return cArray.length;
  }

  /*
  Joining courses and students with allocations
   */
  joinCoursesAndStudents() {
    let courses = [];
    let students = [];

    this.props.run.allocations.courses.map(c => {
      let course = commonActions.getCourseObjById(c.id, this.props.courses);
      course.price = c.price;
      course.count = c.count;
      courses.push(course);
    });
    this.props.run.allocations.students.map(s => {
      let student = commonActions.getCourseObjById(s.id, this.props.students);
      student.rankings = s.rankings;
      student.allocation = s.allocation;
      student.favorite_class = s.favorite_class;
      student.favorite_class_obj = commonActions.getCourseObjById(s.favorite_class, this.props.courses);
      students.push(student);
    });
    this.setState({ courses, students });
    this.setState({ allocationsLoaded: true });
  }

  filterByGroup(/* groupId */) {}

  // default_student_budget is set in config file
  getCoursesOverDefaultStudBudgetHalf() {
    const courses = this.state.courses;
    const excludedCourseIds = this.getCourseHaveZeroTargetCapacity(courses);
    let array = this.props.run.allocations.courses.filter(course => {
      return course.price > (config.default_student_budget / 2) * 100 && excludedCourseIds.indexOf(course.id) === -1;
    });
    return array.length;
  }

  // Changing conditions depending on time
  getCountVsTargetCourses(type) {
    if (type == 1) {
      return this.state.courses.filter(c => {
        return c.count < c.target_capacity;
      }).length;
    } else if (type == 2) {
      return this.state.courses.filter(c => {
        return c.count == c.target_capacity;
      }).length;
    } else if (type == 3) {
      return this.state.courses.filter(c => {
        return c.count > c.target_capacity && c.count <= c.max_capacity;
      }).length;
    } else if (type == 4) {
      return this.state.courses.filter(c => {
        return c.count > c.max_capacity;
      }).length;
    }
  }

  getStudentsInGroup() {
    if (!this.state.allGroups && this.state.filterGroup.id) {
      return this.state.students.filter(
        student => student.rankings.length > 0 && this.state.filterGroup.memberships.find(m => student.id == m.student)
      );
    } else {
      return this.state.students.filter(student => student.rankings.length > 0);
    }
  }

  // Number of students who received below their target number of courses.
  getBelowRankingAllocations() {
    let studentsInGroup = this.getStudentsInGroup();

    let belowRankingAllocations = 0;
    studentsInGroup.map(student => {
      let weightSum = 0;
      student.allocation.map(course => {
        let c = commonActions.getCourseObjById(course, this.props.courses);
        weightSum += c.weight;
      });

      if (weightSum < student.target_course_units) {
        belowRankingAllocations++;
      }
    });
    return (
      belowRankingAllocations +
      ' of them (' +
      Math.round((belowRankingAllocations / studentsInGroup.length) * 100) +
      '%)'
    );
  }

  getStudentsWithRankingsBelowAllocations() {
    let students = this.getStudentsInGroup();
    let z = students.filter(student => {
      // Calculate allocations weight sum
      let weightSum = 0;
      student.allocation.map(course => {
        let c = commonActions.getCourseObjById(course, this.props.courses);
        weightSum += c.weight;
      });

      // Check weightSum
      if (weightSum < student.target_course_units) {
        student.weightSum = weightSum;
        return true;
      } else {
        return false;
      }
    });
    return _.sortBy(z, 'weightSum');
  }

  getGroupStudentsCountWithFavorites() {
    let studentsInGroup = this.getStudentsInGroup();
    let z = studentsInGroup.filter(student => !!student.favorite_class);
    return z.length;
  }

  getGroupStudentsNoFavorite() {
    let studentsInGroup = this.getStudentsInGroup();

    let z = studentsInGroup.filter(
      student => !!student.favorite_class && !!!student.allocation.find(x => x == student.favorite_class)
    );
    return _.sortBy(z, student => student.favorite_class);
  }

  getEconomyLossClasses() {
    return this.state.courses.filter(course => course.price > 0 && course.count < course.target_capacity);
  }

  // 'target' parameter to distinguish tables on page
  showAll(target, length) {
    if (target == 1) {
      if (this.state.showAll1 == 10) {
        this.setState({ showAll1: length });
      } else {
        this.setState({ showAll1: 10 });
      }
    } else if (target == 2) {
      if (this.state.showAll2 == 10) {
        this.setState({ showAll2: length });
      } else {
        this.setState({ showAll2: 10 });
      }
    } else if (target == 3) {
      if (this.state.showAll3 == 10) {
        this.setState({ showAll3: length });
      } else {
        this.setState({ showAll3: 10 });
      }
    } else if (target == 4) {
      if (this.state.showAllFave == 10) {
        this.setState({ showAllFave: length });
      } else {
        this.setState({ showAllFave: 10 });
      }
    }
  }

  // Handle group dropdown change
  handleGroupChange(group) {
    this.setState({ filterGroup: group });
  }

  render() {
    const topClassByPriced = this.getTopClassesByPrice().slice(0, this.state.showAll1);
    const { assignment_complete } = this.props;
    return (
      <Col md={12}>
        <div className="page-title">Assignment Report</div>
        <AdminSteps active="-1" label={this.props.run.slug} assignment_complete={assignment_complete}/>
        {this.props.run.allocations.courses && this.state.allocationsLoaded && this.props.run.id ? ( // Changed || to && to support page reload
          <div>
            <h2>Classes in the Allocation</h2>
            <p>
              Class prices are a function of both students demand and limited capacity. There were{' '}
              {this.props.courses.length} classes, {this.getCoursesWithPositivePrices()} classes were given positive
              prices. Recall that, by default, students have a budget of 100. The top classes by price are:
            </p>
            <div className="c-table classes-table">
              <Table condensed hover>
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Identifier</th>
                    <th>Description</th>
                    <th>Demand</th>
                    <th>Capacity</th>
                    <th>Price</th>
                  </tr>
                </thead>
                <ReactCSSTransitionGroup
                  transitionName="table"
                  component="tbody"
                  transitionEnterTimeout={300}
                  transitionLeaveTimeout={300}
                >
                  {topClassByPriced.map((course, i) => {
                    return (
                      <tr key={i}>
                        <td className="class-desc">
                          <Link to={'/administer/' + localStorage.getItem('run') + '/class/' + course.id}>
                            {course.slug}
                          </Link>
                        </td>
                        <td className="class-desc">{course.identifier}</td>
                        <td className="class-desc">{course.longname}</td>
                        <td className="class-desc">{course.requesting_students}</td>
                        <td className="class-desc">{course.target_capacity}</td>
                        <td className="class-desc">{(course.price / 100).toFixed(1)}</td>
                      </tr>
                    );
                  })}
                </ReactCSSTransitionGroup>
              </Table>
              {this.getTopClassesByPrice().length > 10 ? (
                <div
                  className="show-all"
                  onClick={() => {
                    this.showAll(1, this.getTopClassesByPrice().length);
                  }}
                >
                  {this.state.showAll1 == 10 ? (
                    <span>
                      <i className="fa fa-arrow-down" /> Show All
                    </span>
                  ) : (
                    <span>
                      <i className="fa fa-arrow-up" /> Collapse
                    </span>
                  )}
                </div>
              ) : null}
            </div>
            <p>
              There{' '}
              {this.getCoursesOverDefaultStudBudgetHalf() == 1
                ? 'is ' + this.getCoursesOverDefaultStudBudgetHalf() + ' class '
                : 'are ' + this.getCoursesOverDefaultStudBudgetHalf() + ' classes '}
              that are priced at greater than half of the default student budget. Increasing the number of seats in
              these classes would lead to the largest increases in student welfare.
            </p>
            <ul>
              <li>Class capacities in the allocation were as follows:</li>
              <li>
                {this.getCountVsTargetCourses(1)} {this.getCountVsTargetCourses(1) == 1 ? 'class is ' : 'classes were '}
                allocated less than their target capacity
              </li>
              <li>
                {this.getCountVsTargetCourses(2)} {this.getCountVsTargetCourses(2) == 1 ? 'class is ' : 'classes were '}
                allocated their target capacity exactly
              </li>
              <li>
                {this.getCountVsTargetCourses(3)} {this.getCountVsTargetCourses(3) == 1 ? 'class is ' : 'classes were '}
                allocated between their target and max capacity
              </li>
              <li>
                {this.getCountVsTargetCourses(4)} {this.getCountVsTargetCourses(4) == 1 ? 'class is ' : 'classes were '}
                allocated more than their max capacity
              </li>
            </ul>

            <h2>Students and Fairness</h2>
            <Row className="mb-1">
              <Col md={2}>
                <div className="checkbox-label">All groups</div>
                <div className="form-control allGroupCheck">
                  <input
                    ref="filterByGroup"
                    type="checkbox"
                    name="filterByGroup"
                    checked={this.state.allGroups}
                    onChange={this.handleCheckAllGroups}
                  />
                </div>
              </Col>
              <Col md={4}>
                <div className="checkbox-label">Select Group</div>
                <DropdownList
                  textField="name"
                  data={this.props.groups}
                  caseSensitive={false}
                  minLength={2}
                  filter="contains"
                  onChange={value => this.handleGroupChange(value)}
                  disabled={this.state.allGroups}
                />
              </Col>
            </Row>
            <p>
              In a good assignment, students will be allocated the class that they prefer. However, every student may
              not be able to receive their top class. In this assignment, the following fractions of students were
              assigned to:
            </p>
            <ul>
              {this.getTopRankedInAllocations().map((top, i) => {
                return (
                  <li key={i}>
                    {i == 0 ? 'Their top-ranked class - ' + top + '%' : null}
                    {i == 1 ? 'At least one of their top two classes - ' + top + '%' : null}
                    {i == 2 ? 'At least one of their top three classes - ' + top + '%' : null}
                    {i == 3 ? 'At least one of their top five classes - ' + top + '%' : null}
                  </li>
                );
              })}
            </ul>
            <p className="mt-3">
              There were {this.getAllocationsByGroup().length}{' '}
              {this.getAllocationsByGroup().length == 1 ? 'student' : 'students'}; {this.getBelowRankingAllocations()}{' '}
              received below their target number of courses.
            </p>

            {this.getStudentsWithRankingsBelowAllocations().length != 0 ? (
              <div className="c-table classes-table">
                <Table condensed hover>
                  <thead>
                    <tr>
                      <th />
                      <th>Email</th>
                      <th>Identifier</th>
                      <th>Groups</th>
                      <th>Assigned Course Units</th>
                      <th>Target Course Units</th>
                    </tr>
                  </thead>
                  <ReactCSSTransitionGroup
                    transitionName="table"
                    component="tbody"
                    transitionEnterTimeout={300}
                    transitionLeaveTimeout={300}
                  >
                    {this.getStudentsWithRankingsBelowAllocations()
                      .slice(0, this.state.showAll2)
                      .map((student, i) => {
                        return (
                          <tr key={i}>
                            <td>{i + 1}</td>
                            <td className="class-desc">
                              <Link to={'/administer/' + localStorage.getItem('run') + '/student/' + student.id}>
                                {student.user.email}
                              </Link>
                            </td>
                            <td className="class-desc">{student.identifier}</td>
                            <td className="class-desc">
                              {student.memberships.length != 0
                                ? student.memberships.map((m, i) => {
                                    let group = commonActions.getObjectById(m.group, this.props.groups);
                                    return (
                                      <div key={i}>
                                        <Link to={'/administer/' + localStorage.getItem('run') + '/group/' + group.id}>
                                          {group.name}
                                        </Link>
                                      </div>
                                    );
                                  })
                                : ''}
                            </td>
                            <td className="class-desc">{student.weightSum}</td>
                            <td className="class-desc">{student.target_course_units}</td>
                          </tr>
                        );
                      })}
                  </ReactCSSTransitionGroup>
                </Table>
                {this.getStudentsWithRankingsBelowAllocations().length > 10 ? (
                  <div
                    className="show-all"
                    onClick={() => {
                      this.showAll(2, this.getStudentsWithRankingsBelowAllocations().length);
                    }}
                  >
                    {this.state.showAll2 == 10 ? (
                      <span>
                        <i className="fa fa-arrow-down" /> Show All
                      </span>
                    ) : (
                      <span>
                        <i className="fa fa-arrow-up" /> Collapse
                      </span>
                    )}
                  </div>
                ) : null}
              </div>
            ) : null}

            <p className="mt-3">
              There were {this.getGroupStudentsCountWithFavorites()} students that listed a Favorite class.{' '}
              {this.getGroupStudentsNoFavorite().length}{' '}
              {this.getGroupStudentsNoFavorite().length == 1 ? 'student' : 'students'} did not receive their Favorite
              class.
            </p>
            {this.getGroupStudentsNoFavorite().length != 0 ? (
              <div className="c-table classes-table">
                <Table condensed hover>
                  <thead>
                    <tr>
                      <th />
                      <th>Email</th>
                      <th>Identifier</th>
                      <th>Favorite Class</th>
                    </tr>
                  </thead>
                  <ReactCSSTransitionGroup
                    transitionName="table"
                    component="tbody"
                    transitionEnterTimeout={300}
                    transitionLeaveTimeout={300}
                  >
                    {this.getGroupStudentsNoFavorite()
                      .slice(0, this.state.showAllFave)
                      .map((student, i) => {
                        return (
                          <tr key={i}>
                            <td>{i + 1}</td>
                            <td className="class-desc">
                              <Link to={'/administer/' + localStorage.getItem('run') + '/student/' + student.id}>
                                {student.user.email}
                              </Link>
                            </td>
                            <td className="class-desc">{student.identifier}</td>
                            <td className="class-desc">
                              <Link
                                to={'/administer/' + localStorage.getItem('run') + '/class/' + student.favorite_class}
                              >
                                {student.favorite_class_obj.slug}: {student.favorite_class_obj.longname}
                              </Link>
                            </td>
                          </tr>
                        );
                      })}
                  </ReactCSSTransitionGroup>
                </Table>
                {this.getGroupStudentsNoFavorite().length > 10 ? (
                  <div
                    className="show-all"
                    onClick={() => {
                      this.showAll(4, this.getGroupStudentsNoFavorite().length);
                    }}
                  >
                    {this.state.showAllFave == 10 ? (
                      <span>
                        <i className="fa fa-arrow-down" /> Show All
                      </span>
                    ) : (
                      <span>
                        <i className="fa fa-arrow-up" /> Collapse
                      </span>
                    )}
                  </div>
                ) : null}
              </div>
            ) : null}

            <h2>Loss in the Economy</h2>
            <p>
              At Wharton, we use an economic concept called <span className="italic">deadweight loss</span> to access
              the quality of an allocation. Deadweight loss represents the value of unallocated seats; the unallocated
              seats in positive-price classes are the most likely ones to be filled by students in the add-drop
              aftermarket. Here are the classes with positive prices and unfilled seats:
            </p>
            <div className="c-table classes-table">
              <Table condensed hover>
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Description</th>
                    <th>Demand</th>
                    <th>Target Capacity</th>
                    <th>Price</th>
                  </tr>
                </thead>
                <ReactCSSTransitionGroup
                  transitionName="table"
                  component="tbody"
                  transitionEnterTimeout={300}
                  transitionLeaveTimeout={300}
                >
                  {this.getEconomyLossClasses()
                    .slice(0, this.state.showAll3)
                    .map((course, i) => {
                      return (
                        <tr key={i}>
                          <td className="class-desc">
                            <Link to={'/administer/' + localStorage.getItem('run') + '/class/' + course.id}>
                              {course.slug}
                            </Link>
                          </td>
                          <td className="class-desc">{course.longname}</td>
                          <td className="class-desc">{course.count}</td>
                          <td className="class-desc">{course.target_capacity}</td>
                          <td className="class-desc">{(course.price / 100).toFixed(1)}</td>
                        </tr>
                      );
                    })}
                </ReactCSSTransitionGroup>
              </Table>
              {this.getEconomyLossClasses().length > 10 ? (
                <div
                  className="show-all"
                  onClick={() => {
                    this.showAll(3, this.getEconomyLossClasses().length);
                  }}
                >
                  {this.state.showAll3 == 10 ? (
                    <span>
                      <i className="fa fa-arrow-down" /> Show All
                    </span>
                  ) : (
                    <span>
                      <i className="fa fa-arrow-up" /> Collapse
                    </span>
                  )}
                </div>
              ) : null}
            </div>
            <p>
              A deadweight loss of 0.0% means a completely efficient fair assignment with no empty seats in valuable
              classes. The typical deadweight loss in an assignment at Wharton is around 0.20% of the economy. The
              deadweight loss of this assignment was {this.props.run.allocations.deadweight_loss.toFixed(2)}% of the
              economy.
            </p>
          </div>
        ) : (
          <div className="spinner-box">
            <Spinner spinnerName="three-bounce" className="mt-4" />
          </div>
        )}
      </Col>
    );
  }
}

function mapStateToProps(state) {
  return {
    run: state.run,
    courses: state.courses,
    students: state.students,
    groups: state.groups
  };
}
function mapDispatchToPops(dispatch) {
  return {
    runActions: bindActionCreators(runActions, dispatch),
    courseActions: bindActionCreators(courseActions, dispatch),
    studentActions: bindActionCreators(studentActions, dispatch),
    groupActions: bindActionCreators(groupActions, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToPops
)(DashboardPage);



// WEBPACK FOOTER //
// ./src/components/runs/DashboardPage.js